export default "__VITE_ASSET__CykLM80b__"